export const subTypeToLevelMap = (type) => {
  if (type === "admin") return "Admin";
  else if (type.includes("free")) return "Free";
  else if (type.includes("student_lite")) return "3D Practice";
  else return "Pro-Lite";
};
